/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CancellationRequestEntryInput } from './CancellationRequestEntryInput';
import {
    CancellationRequestEntryInputFromJSON,
    CancellationRequestEntryInputFromJSONTyped,
    CancellationRequestEntryInputToJSON,
} from './CancellationRequestEntryInput';

/**
 * Cancellation request input list for the current order.
 * @export
 * @interface CancellationRequestEntryInputList
 */
export interface CancellationRequestEntryInputList {
    /**
     * Cancellation request entry inputs which contain information about the order entries which are requested to be cancelled
     * @type {Array<CancellationRequestEntryInput>}
     * @memberof CancellationRequestEntryInputList
     */
    cancellationRequestEntryInputs: Array<CancellationRequestEntryInput>;
}

/**
 * Check if a given object implements the CancellationRequestEntryInputList interface.
 */
export function instanceOfCancellationRequestEntryInputList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "cancellationRequestEntryInputs" in value;

    return isInstance;
}

export function CancellationRequestEntryInputListFromJSON(json: any): CancellationRequestEntryInputList {
    return CancellationRequestEntryInputListFromJSONTyped(json, false);
}

export function CancellationRequestEntryInputListFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancellationRequestEntryInputList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cancellationRequestEntryInputs': ((json['cancellationRequestEntryInputs'] as Array<any>).map(CancellationRequestEntryInputFromJSON)),
    };
}

export function CancellationRequestEntryInputListToJSON(value?: CancellationRequestEntryInputList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cancellationRequestEntryInputs': ((value.cancellationRequestEntryInputs as Array<any>).map(CancellationRequestEntryInputToJSON)),
    };
}

